import { useState, type FormEvent } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { QualyzApi } from '../services/qualyz'
import { fehlerText } from '../lib/api'

const MIN = 8

/**
 * Das eigene Konto: Adresse, Stufe, Passwort ändern.
 *
 * Ändern verlangt das bisherige Passwort -- sonst genügt ein offener Rechner.
 * Danach sind alle anderen Anmeldungen beendet; für die laufende Sitzung
 * kommt ein frisches Token zurück, damit niemand aus seiner eigenen Sitzung
 * fliegt, während er gerade das Passwort wechselt.
 */
export default function KontoPage() {
  const { user } = useAuth()
  const [altes, setAltes] = useState('')
  const [neues, setNeues] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [laeuft, setLaeuft] = useState(false)
  const [fehler, setFehler] = useState<string | null>(null)
  const [fertig, setFertig] = useState(false)

  const passt = neues.length >= MIN && neues === wiederholung && altes.length > 0

  const absenden = async (e: FormEvent) => {
    e.preventDefault()
    setFehler(null)
    setLaeuft(true)
    try {
      const antwort = await QualyzApi.passwortAendern(altes, neues)
      if (antwort.access_token) localStorage.setItem('auth_token', antwort.access_token)
      setFertig(true)
      setAltes('')
      setNeues('')
      setWiederholung('')
    } catch (f) {
      setFehler(fehlerText(f))
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="q-page q-page--schmal">
      <section className="q-card">
        <div className="q-card-head">
          <h3 className="q-card-title">Mein Konto</h3>
        </div>
        <p className="q-karte-text">
          <strong>{user?.email}</strong>
          {user?.is_admin ? ' · Verwaltung' : user?.is_pro ? ' · Pro' : ' · kostenlos'}
        </p>
      </section>

      <section className="q-card">
        <div className="q-card-head">
          <h3 className="q-card-title">Passwort ändern</h3>
        </div>
        {fertig && (
          <p className="q-job-result is-ok q-karte-rand">
            Das Passwort ist geändert. Anmeldungen auf anderen Geräten sind damit beendet.
          </p>
        )}
        <form onSubmit={absenden} className="q-formular">
          <label className="q-feld">
            <span>Bisheriges Passwort</span>
            <input
              type="password"
              value={altes}
              onChange={(e) => setAltes(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <label className="q-feld">
            <span>Neues Passwort</span>
            <input
              type="password"
              value={neues}
              onChange={(e) => setNeues(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>
          <label className="q-feld">
            <span>Noch einmal</span>
            <input
              type="password"
              value={wiederholung}
              onChange={(e) => setWiederholung(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>
          <p className="q-feld-hinweis">
            Mindestens {MIN} Zeichen. Länge wirkt mehr als Sonderzeichen, deshalb
            verlangen wir keine.
          </p>
          {fehler && <p className="qa-hinweise q-karte-rand">{fehler}</p>}
          <div className="q-job-foot">
            <span />
            <button type="submit" className="q-btn q-btn-primary" disabled={laeuft || !passt}>
              {laeuft ? 'Wird geändert …' : 'Passwort ändern'}
            </button>
          </div>
        </form>
      </section>
    </div>
  )
}
